export const isLocalEnv = import.meta.env.VITE_ENVIRONMENT === 'local';
export const isDevEnv = import.meta.env.VITE_ENVIRONMENT === 'develop';
